import { SpinnerCenter } from "@shapr3d/frontend-lib";
import { Navigate, useLocation, useParams } from "react-router-dom";

import { useProjectViewLinkInvitation } from "../../hooks/useProjectViewLink";
import { useWebExport } from "../../hooks/useWebExport";
import NotFoundPage from "../../pages/NotFoundPage/NotFoundPage";
import { GenericHeader } from "../Headers/GenericHeader/GenericHeader";

import style from "./ViewLinkRedirect.module.css";

export const ViewLinkRedirect = () => {
  const { viewLinkId } = useParams();
  const location = useLocation();

  const { enabled: isInvitationEnabled } = useProjectViewLinkInvitation();

  const {
    data: webExportData,
    isLoading: isWebExportLoading,
    isError: isWebExportError,
  } = useWebExport();

  if (isWebExportLoading || isInvitationEnabled) {
    return (
      <div className={style.container}>
        <GenericHeader />
        <SpinnerCenter />
      </div>
    );
  }

  if (isWebExportError || !webExportData) {
    return (
      <div className={style.container}>
        <GenericHeader />
        <NotFoundPage />
      </div>
    );
  }

  const projectId = webExportData.webExport.projectId;

  const pathAfterViewLink = location.pathname.split(`/v/${viewLinkId}`)[1] || "";
  const newPath = `/p/${projectId}/v/${viewLinkId}${pathAfterViewLink}`;

  const newUrl = {
    pathname: newPath,
    search: location.search,
    hash: location.hash,
  };

  return <Navigate to={newUrl} replace />;
};
